import { render, staticRenderFns } from "./CbsRefAvailability.vue?vue&type=template&id=65998cc4&scoped=true"
import script from "./CbsRefAvailability.vue?vue&type=script&lang=js"
export * from "./CbsRefAvailability.vue?vue&type=script&lang=js"
import style0 from "./CbsRefAvailability.vue?vue&type=style&index=0&id=65998cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65998cc4",
  null
  
)

export default component.exports